const IMG_ORIGIN = "http://img-vcr.oss-cn-beijing.aliyuncs.com";
const COS_ORIGIN = "https://img-poster-editor-1300308946.cos.ap-beijing.myqcloud.com";
const OSS_ORIGIN = "http://n8n-workflow-file.oss-cn-beijing.aliyuncs.com";
const MIUTA_ORIGIN = "https://sg-miuta-resource.oss-ap-southeast-1.aliyuncs.com";
const OSS_BEIJING = "https://img-vidflow.oss-cn-beijing.aliyuncs.com";
const IMG_EFFECT_SG_ORIGIN = "https://img-effect-sg-new-1300308946.cos.accelerate.myqcloud.com";
const VOD_EFFECT_SG_ORIGIN = "https://vod-effect-sg-1300308946.cos.accelerate.myqcloud.com";

/**
 * 将URL转换为静态代理URL
 * @param url - 原始URL
 * @returns 转换后的URL
 */
export function toStaticProxyUrl(url: string): string {
  if (
    url.startsWith(IMG_ORIGIN) ||
    url.startsWith(COS_ORIGIN) ||
    url.startsWith(OSS_ORIGIN) ||
    url.startsWith(MIUTA_ORIGIN) ||
    url.startsWith(OSS_BEIJING) ||
    url.startsWith(IMG_EFFECT_SG_ORIGIN) ||
    url.startsWith(VOD_EFFECT_SG_ORIGIN)
  ) {
    
    const isDev = typeof import.meta !== "undefined" && !!import.meta.env?.DEV;
    if (isDev) {
      const u = new URL(url);
      if (u.origin === IMG_ORIGIN) {
        const path = u.pathname + (u.search || "");
        url = `/img${path}`;
      }
      if (u.origin === COS_ORIGIN) {
        const path = u.pathname + (u.search || "");
        url = `/cos${path}`;
      }
      if (u.origin === OSS_ORIGIN) {
        const path = u.pathname + (u.search || "");
        url = `/oss${path}`;
      }
      if (u.origin === MIUTA_ORIGIN) {
        const path = u.pathname + (u.search || "");
        url = `/miuta${path}`;
      }
      if (u.origin === OSS_BEIJING) {
        const path = u.pathname + (u.search || "");
        url = `/oss-beijing${path}`;
      }
      if (u.origin === IMG_EFFECT_SG_ORIGIN) {
        const path = u.pathname + (u.search || "");
        url = `/imgeffectsg${path}`;
      }
      if (u.origin === VOD_EFFECT_SG_ORIGIN) {
        const path = u.pathname + (u.search || "");
        url = `/vodeffectsg${path}`;
      }
    }
  }

  return url;
}